import { render } from "./app-modal-transaction-detail.vue?vue&type=template&id=5e08bd0a"
import script from "./app-modal-transaction-detail.vue?vue&type=script&lang=js"
export * from "./app-modal-transaction-detail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__